import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Users, Heart, Star } from 'lucide-react';
export function AboutSection() {
  return <section id="about" className="w-full bg-zinc-950 text-white py-24 px-6 md:px-12 lg:px-20 border-t border-white/5" data-id="element-7" data-mp="2lcybzeqe5fea">
      <div className="max-w-7xl mx-auto" data-id="element-8" data-mp="2be950h019fct">
        {/* Header */}
        <div className="mb-16" data-id="element-9" data-mp="2bdr1r0eye0ve">
          <div className="flex items-center gap-3 mb-4" data-id="element-10" data-mp="27c5fiogj4a8j">
            <div className="w-2 h-2 bg-[#6B7A4A] rounded-full pulse-dot" data-id="element-11" data-mp="27dqa2e2uft6e" />
            <span className="font-['JetBrains_Mono'] text-xs text-[#6B7A4A] tracking-widest uppercase" data-id="element-12" data-mp="22knnwr0ebm08">
              Досьє · Про нас
            </span>
          </div>
          <h2 className="font-['Oswald'] text-5xl md:text-6xl font-bold uppercase tracking-widest" data-id="element-13" data-mp="1snrg6nibn3wq">
            Наша місія
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start" data-id="element-14" data-mp="1nnwl07rijs5v">
          {/* Left Column - Story */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          ease: 'easeOut'
        }} className="lg:col-span-7 space-y-6" data-id="element-15" data-mp="1jp744579nshh">
            <div className="font-['JetBrains_Mono'] text-xs text-zinc-500 tracking-widest uppercase" data-id="element-16" data-mp="1bi2drnmj3z8o">
              FILE-001 / Слово засновників
            </div>

            <h3 className="font-['Oswald'] text-3xl md:text-4xl font-bold uppercase tracking-wide leading-tight text-white" data-id="element-17" data-mp="1gfknhg8deihq">
              Створено ветеранами.
              <br data-id="element-18" data-mp="16ig2hjq9gt2i" />
              <span className="text-[#6B7A4A]" data-id="element-19" data-mp="16hwkk30m24oh">Працюємо з дисципліною.</span>
            </h3>

            <div className="space-y-5 text-zinc-400 text-base leading-relaxed font-['Inter'] max-w-2xl" data-id="element-20" data-mp="3n6jupjomom7t">
              <p data-id="element-21" data-mp="3rb1cjdbfgpfy">
                WIN CODE GARAGE заснували українські ветерани, які перенесли
                цінності фронту до майстерні: точність, відповідальність і
                абсолютну чесність у спілкуванні з клієнтом.
              </p>
              <p data-id="element-22" data-mp="1o0o97ze310z9">
                Кожна робота фіксується, кожна кошторисна позиція прозора. Ми не
                нав'язуємо зайвого, не зрізаємо кутів і не ховаємося за
                технічним жаргоном. Якщо ми взялися — виконаємо у строк, за
                стандартом і з гарантією на результат.
              </p>
              <p data-id="element-23" data-mp="1a0dhku4y7id1">
                Наші майстри сертифіковані, процеси задокументовані, а клієнти
                для нас — побратими. Це той рівень, на якому ми працюємо.
              </p>
            </div>

            {/* Tactical values list */}
            <div className="grid grid-cols-2 gap-x-8 gap-y-4 pt-6 max-w-xl" data-id="element-24" data-mp="105ljzqbd8vi9">
              {[{
              code: '01',
              label: 'Дисципліна'
            }, {
              code: '02',
              label: 'Чесність'
            }, {
              code: '03',
              label: 'Точність'
            }, {
              code: '04',
              label: 'Відданість'
            }].map(val => <div key={val.code} className="flex items-center gap-3 border-l-2 border-[#6B7A4A] pl-3 py-1" data-id="element-25" data-mp="3gpxdsiqk6u1t">
                  <span className="font-['JetBrains_Mono'] text-xs text-zinc-600" data-id="element-26" data-mp="2o105n8g2adms">
                    {val.code}
                  </span>
                  <span className="font-['Oswald'] text-sm uppercase tracking-widest text-white" data-id="element-27" data-mp="2sz1llki6xwu1">
                    {val.label}
                  </span>
                </div>)}
            </div>
          </motion.div>

          {/* Right Column - Community Impact Card */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.15,
          ease: 'easeOut'
        }} className="lg:col-span-5" data-id="element-28" data-mp="d85pbebmss8d">
            <div className="relative bg-neutral-900/50 border border-white/10 p-8" data-id="element-29" data-mp="1q65tudgvmdj4">
              <div className="absolute top-0 left-0 w-4 h-4 border-t-2 border-l-2 border-[#6B7A4A]" data-id="element-30" data-mp="253gdia3oappx" />
              <div className="absolute top-0 right-0 w-4 h-4 border-t-2 border-r-2 border-[#6B7A4A]" data-id="element-31" data-mp="20555m4wxupac" />
              <div className="absolute bottom-0 left-0 w-4 h-4 border-b-2 border-l-2 border-[#6B7A4A]" data-id="element-32" data-mp="2dwjs4lq218m5" />
              <div className="absolute bottom-0 right-0 w-4 h-4 border-b-2 border-r-2 border-[#6B7A4A]" data-id="element-33" data-mp="29w9k73ipc84n" />

              <div className="mb-8" data-id="element-34" data-mp="2nt4vl2mfebnv">
                <div className="font-['JetBrains_Mono'] text-[10px] text-zinc-500 tracking-widest mb-2 uppercase" data-id="element-35" data-mp="2iwed68n5f3za">
                  Брифінг / Підтримка ЗСУ
                </div>
                <h3 className="font-['Oswald'] text-2xl font-bold text-white uppercase tracking-wide leading-tight" data-id="element-36" data-mp="32g3h6gylqbuo">
                  Поруч із
                  <br data-id="element-37" data-mp="2siqk2us71l5b" />
                  <span className="text-[#6B7A4A]" data-id="element-38" data-mp="2sjiew3dyveuj">нашими захисниками</span>
                </h3>
              </div>

              <div className="space-y-5" data-id="element-39" data-mp="2xkxzjuc8fjce">
                <div className="flex items-start gap-4" data-id="element-40" data-mp="2jr6p8jqofvfm">
                  <div className="p-2 bg-[#6B7A4A]/10 border border-[#6B7A4A]/20 shrink-0" data-id="element-41" data-mp="2jpluou4d4chr">
                    <Shield className="w-4 h-4 text-[#6B7A4A]" data-id="element-42" data-mp="2ok9nh56eft25" />
                  </div>
                  <div data-id="element-43" data-mp="29v3pfkjas8vu">
                    <div className="font-['Oswald'] text-sm uppercase tracking-widest text-white mb-1" data-id="element-44" data-mp="29rfwonlofqi6">
                      Пріоритет для ЗСУ
                    </div>
                    <p className="text-zinc-400 text-sm leading-relaxed" data-id="element-45" data-mp="20tdyeftbvbyl">
                      Чинні військовослужбовці отримують пріоритетний запис і
                      знижку на всі види ремонту.
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4" data-id="element-46" data-mp="6jp93wldlnus">
                  <div className="p-2 bg-[#6B7A4A]/10 border border-[#6B7A4A]/20 shrink-0" data-id="element-47" data-mp="1lneqfii2240">
                    <Users className="w-4 h-4 text-[#6B7A4A]" data-id="element-48" data-mp="1jayq7way1tl" />
                  </div>
                  <div data-id="element-49" data-mp="3spvn1juz2vmx">
                    <div className="font-['Oswald'] text-sm uppercase tracking-widest text-white mb-1" data-id="element-50" data-mp="uab8kzhbdzt6">
                      Робота для ветеранів
                    </div>
                    <p className="text-zinc-400 text-sm leading-relaxed" data-id="element-51" data-mp="p95b6ocplodb">
                      Понад 60% нашої команди — ветерани. Проводимо навчання й
                      адаптацію тих, хто повертається з фронту.
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4" data-id="element-52" data-mp="353p5a5vqy1ji">
                  <div className="p-2 bg-[#6B7A4A]/10 border border-[#6B7A4A]/20 shrink-0" data-id="element-53" data-mp="31097v7burx5r">
                    <Heart className="w-4 h-4 text-[#6B7A4A]" data-id="element-54" data-mp="1gj9v7mb6tsyv" />
                  </div>
                  <div data-id="element-55" data-mp="1kk260jzpk5x9">
                    <div className="font-['Oswald'] text-sm uppercase tracking-widest text-white mb-1" data-id="element-56" data-mp="1kjk354ijitgd">
                      Внесок у громаду
                    </div>
                    <p className="text-zinc-400 text-sm leading-relaxed" data-id="element-57" data-mp="1ua4wacfg35rw">
                      Частина кожного замовлення йде на реабілітацію ветеранів і
                      підтримку їхніх родин.
                    </p>
                  </div>
                </div>
              </div>

              <div className="mt-8 pt-6 border-t border-white/10 grid grid-cols-3 gap-4" data-id="element-58" data-mp="24a5jwakck81w">
                <div data-id="element-59" data-mp="287tk9t4t6t16">
                  <div className="font-['Oswald'] text-2xl font-bold text-[#6B7A4A]" data-id="element-60" data-mp="2d8qyjump72xe">
                    60%
                  </div>
                  <div className="font-['JetBrains_Mono'] text-[10px] text-zinc-500 tracking-widest uppercase mt-1" data-id="element-61" data-mp="dwy8yj28ozup">
                    Ветерани в команді
                  </div>
                </div>
                <div data-id="element-62" data-mp="2krgr6ahaija0">
                  <div className="font-['Oswald'] text-2xl font-bold text-[#6B7A4A]" data-id="element-63" data-mp="2kqp5brdhvzwx">
                    -20%
                  </div>
                  <div className="font-['JetBrains_Mono'] text-[10px] text-zinc-500 tracking-widest uppercase mt-1" data-id="element-64" data-mp="2uibkfysyej4y">
                    Знижка для ЗСУ
                  </div>
                </div>
                <div data-id="element-65" data-mp="21tnz6387ftre">
                  <div className="font-['Oswald'] text-2xl font-bold text-[#6B7A4A] flex items-center gap-1" data-id="element-66" data-mp="21sw0ukn83hxf">
                    <Star className="w-5 h-5 fill-[#6B7A4A]" data-id="element-67" data-mp="1xt420znmsq59" />
                  </div>
                  <div className="font-['JetBrains_Mono'] text-[10px] text-zinc-500 tracking-widest uppercase mt-1" data-id="element-68" data-mp="2bs3pi3zeqyzu">
                    Пріоритетний запис
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}